export const MAIN_NAVIGATION = Object.freeze([
  Object.freeze({ id: 'dashboard', label: 'Дашборд', target: 'dashboard', permission: ['dashboard', 'view'] }),
  Object.freeze({ id: 'fleet', label: 'Флот', target: 'fleet', permission: ['vessels', 'view'] }),
  Object.freeze({ id: 'agents', label: 'Агенты', target: 'agents', permission: ['agents', 'view'] }),
  Object.freeze({ id: 'instructions', label: 'Рейсовые задания', target: 'instructions', permission: ['instructions', 'view'] }),
  Object.freeze({ id: 'charterers', label: 'Фрахтователи', target: 'charterers', permission: ['charterers', 'view'] }),
  Object.freeze({ id: 'disp_mech', label: 'Дисп.мех', target: 'disp_mech', permission: ['disp_mech', 'view'] }),
  Object.freeze({ id: 'information', label: 'Информация', target: 'information', permissionAny: Object.freeze([
    Object.freeze(['information','view']), Object.freeze(['cargos','view']), Object.freeze(['dictionaries','view']), Object.freeze(['transfer','view']),
  ]) }),
]);

export const UTILITY_NAVIGATION = Object.freeze([
  Object.freeze({ id: 'health', label: 'Состояние системы', target: 'health', permission: ['health','view'], iconOnly: true }),
]);

export const ACCOUNT_NAVIGATION = Object.freeze([
  Object.freeze({ id: 'requests', label: 'Заявки на доступ', target: 'requests', permission: ['requests','view'] }),
  Object.freeze({ id: 'users', label: 'Пользователи', target: 'users', permission: ['users','view'] }),
]);

export const ROUTE_NAVIGATION = Object.freeze([...MAIN_NAVIGATION, ...UTILITY_NAVIGATION, ...ACCOUNT_NAVIGATION]);
export const PRIMARY_NAVIGATION = ROUTE_NAVIGATION;

export const LEGACY_NAVIGATION_REDIRECTS = Object.freeze({
  cargos: Object.freeze({ page: 'information', section: 'cargos' }),
  dictionaries: Object.freeze({ page: 'information', section: 'lookups' }),
  info: Object.freeze({ page: 'information', section: 'overview' }),
  vessels: Object.freeze({ page: 'fleet', section: '' }),
  voyage: Object.freeze({ page: 'instructions', section: '' }),
  voyages: Object.freeze({ page: 'instructions', section: '' }),
  port_calls: Object.freeze({ page: 'instructions', section: '' }),
  notifications: Object.freeze({ page: 'dashboard', section: '' }),
  profile: Object.freeze({ page: 'dashboard', section: '' }),
});

export function canAccessNavigationItem(item, permissions) {
  if (item.authenticated === true) return true;
  if (Array.isArray(item.permission)) return Boolean(permissions.can(...item.permission));
  if (Array.isArray(item.permissionAny)) return item.permissionAny.some(rule => permissions.can(...rule));
  return false;
}

export function resolveNavigationTarget(page, section = '') {
  const normalized = String(page || '').trim().toLowerCase();
  const redirect = LEGACY_NAVIGATION_REDIRECTS[normalized];
  if (redirect) return { ...redirect };
  if (normalized === 'no-access') return { page: 'no-access', section: '' };
  return {
    page: ROUTE_NAVIGATION.some(item => item.id === normalized) ? normalized : 'dashboard',
    section: String(section || '').trim().toLowerCase(),
  };
}
